<template>
    <div class="chaton-whatsappchatfloat">
        <div class="chaton-sidebarhead">
            <h2 v-if="chatonLayout == 'layout2'">{{TRANS.layout2_list_title}}</h2>
            <p v-if="chatonLayout == 'layout2'" v-html="whatsappText"></p>
            <h2 v-else>{{TRANS.whatsapp_list_title}}</h2>
            <a v-if="isShowCloseButton && chatonLayout == 'layout2'" href="javascript:void(0);" class="chaton-closeremovechat"><i class="chatonicon chaton-x"  @click.prevent="showWidget()" ></i></a>
            <whatsapp-image :ImageColor="imageProps" />
        </div>
        <div class="chaton-userlist_tab">
            <div class="chaton-sidebarhead_search">
                <div class="chaton-form-group">
                    <i class="chatonicon chaton-search"></i>
                    <input type="search" v-model="search" @input="userSearch()" class="chaton-form-control" :placeholder="TRANS.search" />
                </div>
            </div>
            <div class="chaton-willrespond">
                <span>{{TRANS.list_respond_text}}</span>
            </div>
            <ul id="chaton_conv_list" v-if="Object.keys(whatsappList).length" @scroll.prevent="userListScrollHandler($event)" class="conversation-list">
                <li @click.prevent="openConversation( whatsappUser )" class="chaton-userbar chaton-whatsapp-user" :class="{'active' : whatsappUser.chatId == chatInfo.chatId, 'chaton-notavailable' : !whatsappUser.isOnline}" v-for="(whatsappUser, index ) in whatsappList" :key="index + '_' + Math.floor(Math.random() * 99999999)" >
                    <figure class="chaton-userbar_profile chaton-profileuserstatus">
                        <span class="chaton-userstatus" :class="whatsappUser.isOnline ? 'online' : 'offline'"></span>
                        <img :src="whatsappUser.userAvatar ? whatsappUser.userAvatar : defaultAvatar" :alt="whatsappUser.userName">
                    </figure>
                    <div class="chaton-userbar_title">
                        <em v-if="whatsappUser.userDesignation">{{whatsappUser.userDesignation}}</em>
                        <h3 v-if="whatsappUser.userName">{{ whatsappUser.userName | capitalize }}</h3>
                        <p v-if="whatsappUser.startTime && whatsappUser.endTime"><span> {{whatsappUser.startTime}} - {{whatsappUser.endTime}}</span> <span v-if="whatsappUser.GMTTimezone">( GMT&nbsp;{{whatsappUser.GMTTimezone}} hrs ) </span> </p>
                        <p v-else> <span>{{TRANS.offline}}</span></p>
                    </div>
                    <div class="chaton-userbar_right">
                        <a href="javascript:void(0);" class="chaton-whatsappbtn">
                            <whatsapp-image />
                        </a>
                    </div>
                </li>
                <chat-inner-loader v-if="isLoading"/>
            </ul>
            <template v-else>
                <chat-loader v-if="isLoading"/>
                <empty-view v-else :isSidebarProps="true" :listIcon="'chatonicon chaton-user-plus'"/> 
            </template>
        </div>
    </div>
</template>

<script>
import EmptyView from "../EmptyView/EmptyView.vue";
import ChatLoader from "../ChatLoaders/ChatLoader.vue";
import ChatInnerLoader from "../ChatLoaders/ChatInnerLoader.vue";
import AVATAR from "../resources/avatar.png";
import WhatsappImage from "./WhatsappImage.vue";
import moment from 'moment-timezone';
import jQuery from "jquery";
import { mapState } from 'vuex';
const CHATON_SETTINGS           = window.chaton_scripts_vars.chatSetting;
export default {
    name : "WhatsappUsersList",
    components:{
        EmptyView,
        ChatLoader,
        ChatInnerLoader,
        WhatsappImage
    },
    data(){
        return{
            defaultAvatar : AVATAR,
            search      : '',
            timer : null,
            chatonLayout            : CHATON_SETTINGS.chatonLayout,
            isLoadUserChat : false,
        }
    },
    computed : {
        imageProps : function(){
            if(CHATON_SETTINGS.chatonLayout == 'layout1'){
                return 'white';
            }
            return 'lightGreen';
        },
        whatsappText : function (){
            let text = CHATON_SETTINGS.translations.whatsapp_support_desc;
            let convName = '<span>'+CHATON_SETTINGS.translations.conversation_name_txt+'</span>';
            return text.replace('{{conversation_name}}', convName);
        }, 
        ...mapState({
            whatsappList : state => {
                let userList = state.whatsappList
                if(Object.keys(userList).length){
                    let utcDate         = moment.utc().format('YYYY-MM-DD HH:mm:ss'); // in utc
                    let utcCutoff       = moment.utc(utcDate, 'YYYYMMDD HH:mm:ss');
                    return Object.values(userList).map( whatsappUser => {
                        let timeZoneDate    = utcCutoff.clone().tz(whatsappUser.usertimeZone);
                    
                        let timeZoneDay     = timeZoneDate.format('dddd').toLowerCase(); 
                        let currentDate     = timeZoneDate.format('YYYY-MM-DD');
                        let currentDatetime = timeZoneDate.format('YYYY-MM-DD HH:mm:ss');
                        
                        let currentDay      = whatsappUser.availableTime[timeZoneDay];
                        let isOnline        = false;
                        let GMTTimezone     = 0;
                        if(currentDay){
                            
                            let startDateTime   = `${currentDate} ${currentDay['start_time']}`;
                            let endDateTime     = `${currentDate} ${currentDay['end_time']}`;
                                isOnline        = moment(currentDatetime).isBetween( startDateTime, endDateTime );

                            let currentTimeZone     = moment.tz.guess();
                            let currentUtcCutoff    = utcCutoff.clone().tz(currentTimeZone, true);

                            let userTimeZoneCutOff      = Number(timeZoneDate.format('Z').split(':')[0]);
                            let currentTimeZoneCutOff   = Number(currentUtcCutoff.format('Z').split(':')[0]);

                            let timeZoneDiff    = currentTimeZoneCutOff - userTimeZoneCutOff;
                                GMTTimezone     = timeZoneDiff * (-1);

                            let currentZoneDate     = currentUtcCutoff.format('YYYY-MM-DD');
                            let _startDateTime      = `${currentZoneDate} ${currentDay['start_time']}`;
                            let _endDateTime        = `${currentZoneDate} ${currentDay['end_time']}`;
                            whatsappUser.startTime  = moment(_startDateTime).format('hh:mm A');
                            whatsappUser.endTime    = moment(_endDateTime).format('hh:mm A');
                        }
                        whatsappUser.isOnline = isOnline
                        whatsappUser.GMTTimezone = GMTTimezone
                        return whatsappUser
                    });
                } else {
                    return []
                }
            },
            isShowCloseButton   : state => {
                if(state.windowWidth > 0 && state.windowWidth <= 768){
                    return true
                }
                return false
            },
            whatsappListFlag      : state => state.whatsappListFlag,
            whatsappListOffset    : state => state.whatsappListOffset,
            noMoreWhatsappUsers   : state => state.noMoreWhatsappUsers,
            whatsappUserSearch    : state => state.whatsappUserSearch,
            chatInfo              : state => state.chatInfo,
            userProfile           : state => state.userProfile,
        }),
    },
    methods:{
        alertBox( type, title, description ) { // type : warning, error, success, info, question
            this.$swal({
                icon: type,
                title: title,
                text: description,
                showCloseButton: true,
                showConfirmButton: false,
            })
        },
        showWidget(){
            this.$root.$emit('showWidget');
        },
        userSearch(){
            this.$store.commit('updateRecordList', {RecordList: 'noMoreWhatsappUsers', RecordListValue: false});
            this.isScrolling = false;
            clearTimeout(this.timer); 
            this.timer = setTimeout(()=>{
                this.updateListRecord( {} );
                this.$store.commit('updateOffset', {offset:'whatsappListOffset', offsetValue: 0});
                this.$store.commit('updateSearch', {search:'whatsappUserSearch', searchValue: this.search});
                this.getUsersList();
                this.updateOffset();
            }, 800)
        },
        async getUsersList(){
            if ( !this.noMoreWhatsappUsers ) {
                this.isLoading = true;
                let response = await this.axios.get('load-chaton-users?userId='+this.userId+'&offset=' + this.whatsappListOffset + '&search=' + this.search)
                this.isLoading = false;
                if( response.data.type == "success" ) {
                    let currentMoreRecord = Object.keys(response.data.userList).length == 0 ? true : false;
                    this.$store.commit('updateRecordList', {RecordList: 'noMoreWhatsappUsers', RecordListValue: currentMoreRecord});
                    if( !this.whatsappListFlag ) {
                        this.$store.commit('updateListFlag', {flag: 'whatsappListFlag', flagValue:true});
                    }
                    this.updateListRecord( response.data.userList )
                } else if(response.data.type == "error"){
                    this.alertBox('error', this.TRANS.error_title, response.data.message_desc);
                }
            }
        },
        updateOffset(){
            let currentOffset = this.whatsappListOffset + this.RecordLimit;
            this.$store.commit('updateOffset', {offset:'whatsappListOffset', offsetValue: currentOffset});
        },
        // Handles user list scroll
        userListScrollHandler(elem) {
            if ( (elem.target.offsetHeight + elem.target.scrollTop) + 1 >= elem.target.scrollHeight ) {
                this.isScrolling = true;
                this.getUsersList();
                this.updateOffset();
            }
        },
        openConversation( params ){
            let width = jQuery('.chaton-chat').width();
            if ( width <= 768){
                jQuery('.chaton-chat').addClass("chaton-opnchatbox")
            }
            this.$store.commit('updateChatInfo', { data: params });
        },
        updateListRecord( recList ){
            let data = {
                'list'      : recList,
                'listType'  : 'whatsappList',
                'isScrolling' : this.isScrolling
                }
            this.$store.commit('updateTabListRecord', data);
            setTimeout(()=>{
                jQuery('.chaton-users-list .conversation-list').addClass('active');
            },200)
        },
    },
    created(){
        if(!Object.keys(this.whatsappList).length || !this.whatsappListFlag ){
            this.getUsersList();
            this.updateOffset();
        }
    },
    mounted(){
        this.search = this.whatsappUserSearch;
    }

}
</script>
<style>
.chaton-closechat{
    margin-left: auto;
    color: #fff;
    font-size: 28px;
    text-decoration: none;
}
.chaton-userbar_title {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 15px;
}
.chaton-userbar_title > em{
    display: block;
    margin: 0 0 2px;
    color: #3C57E5;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    font-style: normal;
    
}
.chaton-userbar_title h3{
    font-size: 16px;
    line-height: 19px;
    white-space: nowrap;
    overflow: hidden;
    margin: 0;
    text-overflow: ellipsis;
}
.chaton-userbar_title > p{
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    align-items: center;
    line-height: 22px;
    color: var(--secwhatsappcolor);
}
.chaton-floatchat_title-right a i{display: block;}
.chaton-userbar_title > p span{
    margin: 0;
    line-height: 22px;
    color: var(--terwhatsappcolor);
}
.chaton-userbar_title > p em{
    font-style: normal;
    line-height: 22px;
}
.chaton-whatsappbtn{
    display: flex;
    align-items: center;
    border-radius: 60px;
    padding:  8.5px 14.5px;
    border: 1.5px solid var(--themewhatsappcolor);
}
.chaton-whatsappbtn svg path{fill: var(--themewhatsappcolor);}
.chaton-whatsappbtn svg{
    margin-right: 10px;
}
.chaton-whatsappbtn span{
    color: var(--secwhatsappcolor);
    font: 700 13px/20px var(--primchatfont);
}
.chaton-userlist_tab {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 70px);    
}
.chaton-inner-loaader{
    bottom: 0;
}
.chaton-sidebarhead {
	z-index: 2;
	padding: 20px;
	display: flex;
	align-items: center;
	position: relative;
    background: var(--themewhatsappcolor);
}
.chaton-sidebarhead > img {
	margin-right: 10px;
	border-radius: 50% !important;
	width: 50px;
	height: 50px;
}
.chaton-whatsappsidepopup{
  position: relative;
  z-index: 9999999;
  color: var(--secwhatsappcolor);
  font: 400 14px/26px  var(--terwhatsappcolor);
}
.chaton-sidebarhead > h2 {
	color: #fff !important;
	letter-spacing: 0.5px;
	font-size: 22px;
	margin: 0;
	line-height: 30px;
	white-space: nowrap;
	overflow: hidden;
	padding-top: 0;
	text-overflow: ellipsis;
}
.chaton-userlist_tab li.chaton-userbar:last-child {
    margin-bottom: 40px;
}

.chaton-sidebarhead>a:hover{color: #fff;}
.chaton-sidebarhead_search {
  width: 100%;
  position: relative;
  padding: 20px;
  background: #ffffff;
  align-self: flex-start;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: 1px solid #ddd;
}
.chaton-sidebarhead_search h3 {
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 0 10px;
}
.chaton-sidebarhead_search .chaton-form-group i {
  position: absolute;
  left: 18px;
  font-size: 18px;
  color: var(--terwhatsappcolor);
}
.chaton-sidebarhead_search .chaton-form-group {
    padding: 0;
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
}
.chaton-sidebarhead_search .chaton-form-group input {
    font-size: 14px;
    padding-left: 45px;
    width: 100%;
    height: 40px;
    outline: none;
    border-radius: 3px;
}
.chaton-userlist_tab ul {
  height: calc(100% - 116px);
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-y: auto;
}
.chaton-userlist_tab li {
  list-style-type: none;
  width: 100%;
  margin: 0;
}
.chaton-userbar {
  padding: 20px !important;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.chaton-userbar_profile {
    flex: none;
    width: 100%;
    max-width: 50px;
    height: 50px;
    border-radius: 50%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f7f7f7;
    transition: all 0.3s ease-in-out;
    position: relative;
}
.chaton-userbar_profile img {
  width: 100%;
  margin: 0 auto;
  height: 50px;
  display: block;
  object-fit: cover;
  border-radius: 50px !important;
}
.chaton-userstatus {
    font-size: 14px;
    line-height: 26px;
    letter-spacing: 0.01em;
    display: inline-flex;
    vertical-align: middle;
    align-items: center;
    right: 0;
    bottom: 0;
    z-index: 1;
    position: absolute;
}
.chaton-userstatus::before {
    content: '';
    margin: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    display: inline-block;
}
.chaton-userbar_profile .chaton-userstatus:before {
    margin: 0;
    width: 14px;
    height: 14px;
    border: 3px solid #fff;
}
.chaton-userstatus.online:before {
  background-color: #22C55E;
}
.chaton-userstatus.offline:before {
  background-color: #ddd;
}
.chaton-userstatus.away:before {
  background-color: #EAB308;
}
.chaton-userstatus.notify:before {
  background-color: #FF7300;
}
.chaton-userbar.chaton-notavailable {
    mix-blend-mode: luminosity;
}
.chaton-userbar_right {
  text-align: right;
  margin-left: auto;
  flex: none;
  padding-left: 10px;
}
.chaton-userbar_right a{text-decoration: none !important;}
.chaton-userbar_right > span {
  display: block;
  font-size: 14px;
  line-height: 24px;
  color: var(--terwhatsappcolor);
}
.chaton-userlist_tab li + li {
    border-top: 1px solid #ddd;
}

@media (max-width: 420px){
    .chaton-whatsappbtn{
        padding: 13.5px;
    }
    .chaton-whatsappbtn span{
        display: none;
    }
    .chaton-whatsappbtn svg{
        margin: 0;
    }
}
/* NEWWIDGET */
.chaton-willrespond{
    background: #F7F7F7;
    box-shadow: inset 0px -1px 0px #eeeeee;
    padding: 10px 20px;
    display: flex;
    justify-self: center;
    align-items: center;
    text-align: center;
    width: 100%;
}
.chaton-willrespond span{
    color: #999999;
    font-size: 13px;
    line-height: 18px;
    font-weight: 600;
    display: inline-block;
    font-family: var(--secchatfont);
    width: 100%;
    text-align: center;
}
.chaton-users-list::after{
        position: absolute;
        content: '';
        right: 48px;
        display: inline-block;
        z-index: 1111;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #fff;
        box-shadow: inset 1px -1px 0px #EEEEEE;
     
}
.chaton-users-list .chaton-sidebarhead_search{
    box-shadow: inset 0px -1px 0px #eeeeee;
    border: 0;
}
.chaton-users-list .conversation-list{
    padding:20px;
    height: calc(100% - 235px);
}
.chaton-users-list  .chaton-chat_sidebar{
    border-radius:0 0 10px 10px;
    display: block !important;
}
.chaton-users-list .conversation-list li {
    border-radius: 0px 10px 10px 0px;
    border: 1px solid #EEEEEE;
    padding: 16px 20px !important;
    box-shadow: 0px 4px 6px rgb(0 0 0 / 0) ,inset 3px 0px 0px #25d366;
    transition: all .300s ease-in-out;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    opacity: 0;
    -webkit-transform: translateY(-10px);
    -moz-transform: translateY(-10px);
    -ms-transform: translateY(-10px);
    -o-transform: translateY(-10px);
    transform: translateY(-10px);
    position: relative;
}
.chaton-users-list.active {
  max-height: 600px;
 -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
}
.conversation-list.active li {
  opacity: 1;
  -webkit-transform: translateY(0px);
  -moz-transform: translateY(0px);
  -ms-transform: translateY(0px);
  -o-transform: translateY(0px);
  transform: translateY(0px);
}
.conversation-list.active li:nth-of-type(1) {
  transition-delay: 0.3s;
}
.conversation-list.active li:nth-of-type(2) {
  transition-delay: 0.6s;
}
.conversation-list.active li:nth-of-type(3) {
  transition-delay: 0.7s;
}

.conversation-list.active li:nth-of-type(4) {
  transition-delay: 0.8s;
}

.conversation-list.active li:nth-of-type(5) {
  transition-delay: 0.9s;
}
.chaton-users-list .conversation-list li:hover{
    box-shadow:0px 4px 6px rgb(0 0 0 / 7%), inset 3px 0px 0px #25D366 ;
}
.chaton-users-list .conversation-list li + li {
    margin: 10px 0 0;
}
.chaton-users-list .chaton-userbar_title h3 {
    font-size: 18px;
    line-height: 19px;
}
.chaton-users-list .chaton-userbar_title > em {
    display: block;
    margin: 0 0 2px;
    color: #3C57E5;
    font-size: 13px;
    font-weight: 600;
    line-height: 17px;
}
.chaton-users-list .chaton-userbar_title > p span {
    font-size:13px;
    margin: 2px 0 0;
    line-height: 18px;
    font-weight: 600;
    font-family: var(--secchatfont);
}
.chaton-users-list .chaton-whatsapp-user .chaton-userbar_right .chaton-whatsappbtn {
    background: var(--themewhatsappcolor);
    width: 44px;
    border-radius: 50%;
    line-height: 44px;
    height: 44px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

}
.chaton-users-list .chaton-whatsapp-user .chaton-userbar_right .chaton-whatsappbtn svg{
    margin:0;
}
.chaton-users-list .chaton-whatsappbtn svg path {
    fill: #ffffff;
}
.chaton-users-list .conversation-list li.chaton-notavailable .chaton-userbar_right .chaton-whatsappbtn{
    background:#ffffff;
    border: 2px solid #EEEEEE;
}
.chaton-users-list .conversation-list li.chaton-notavailable{
    background: #F7F7F7;
    mix-blend-mode: normal;
    box-shadow: 0px 4px 6px rgb(0 0 0 / 0%), inset 3px 0px 0px #999999;
}
.chaton-users-list .conversation-list li.chaton-notavailable figure {
    mix-blend-mode: luminosity;
}
.chaton-singleimg.chaton-notavailable img{
    filter: grayscale(1);
}
.chaton-users-list .conversation-list li.chaton-notavailable:hover{
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07), inset 3px 0px 0px #999999;
}
.chaton-users-list .conversation-list li.chaton-notavailable svg path {
    fill: #999999;
}
.chaton-users-list .chaton-userstatus.offline:before {
    background-color: #999999;
}
.chaton-users-list  .chaton-userbar_title {
    margin-left: 10px;
}
.chaton-users-list .conversation-list li.chaton-notavailable .chaton-userbar_title > em {
    color: #3C57E5;
     font-family: var(--secchatfont);
}
.chaton-users-list .chaton-sidebarhead {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 20px 16px 67px;
    border-radius: 10px 10px 0 0;
}
.chaton-users-list .chaton-sidebarhead svg {
    position: absolute;
    left: 0;
    opacity: 0.5;
}
.chaton-users-list .chaton-sidebarhead > h2 {
    margin: 0 0 4px;
    font-size:20px;
    line-height:22px;
    white-space: normal;
}
.chaton-users-list .chaton-sidebarhead p{
    font-size: 15px;
    line-height: 22px;
    color: #fff;
    font-weight: 400;
    width: 90%;

}
.chaton-users-list .chaton-sidebarhead p span {
    font-weight: 700;
}
.chaton-chatsidebar_float.chaton-users-list{
    max-width: 400px;
    border-radius: 10px;
    top: 20vh;
    height: auto;
    bottom: 146px;
}
.chaton-users-list .chaton-userlist_tab {
       height: 100%;
}
.chaton-users-list .chaton-whatsappchatfloat{
     width: 100%;
    height: 100%;
}
.chaton-users-list .chaton-userlist_tab li.chaton-userbar:last-child {
    margin-bottom: 0;
}
.chaton-chatsidebar_float:not(.chaton-widgetclose) + .chaton-chatfloatholder .chaton-chatfloat.chaton-layouttwo{
    visibility: visible;
    opacity: 1;
    display: block;
    height: 100%;
}
.chaton-chatfloat.chaton-layouttwo > span a{
    text-decoration: none;
    width: 67px;
    height: 67px;
}
.chaton-chatfloat.chaton-layouttwo > span a i{
    color: #ffffff;
}
.chaton-chatfloatholder.chaton-floatholdertwo{
    right: 40px;
}
.chaton-floatholdertwo .chaton-floatchat_content {
        border-radius: 20px 20px 0 0;
}
.chaton-floatholdertwo .chaton-floatchat_titlev2{
    border-radius: 20px 20px 0 0;
}
.chaton-floatholdertwo .chaton-floatchat_titlev2 .chaton-singleimg .chaton-userstatus {
    outline: 3px solid #128C7E;
    border-width: 0;
}
.chaton-floatholdertwo .chaton-floatchat {
    right: 450px;
}
/* otherlayout */
.chaton-layout-one .conversation-list {
    padding: 0;
    height: calc(100% - 186px);

}
.chaton-layout-one .chaton-users-list .conversation-list li + li {
    margin: 0;
    bottom: 0;
    border-radius: 0;
}
.chaton-layout-one .chaton-users-list .conversation-list li.chaton-notavailable{
    box-shadow:none;
    border-radius: 0;
}
.chaton-layout-one .chaton-users-list .conversation-list li {
    padding: 20px !important;
    box-shadow: none;
}
.chaton-layout-one .chaton-users-list .chaton-sidebarhead svg{
    width: 22px;
    opacity: 1;
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translate(0%, -50%);
}
.chaton-layout-one .chaton-users-list .chaton-sidebarhead {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 20px 16px 52px;
}
.chaton-layout-one .chaton-users-list .chaton-sidebarhead > h2 {
    margin: 0;
}
.chaton-layout-one .chaton-users-list .conversation-list li.chaton-notavailable .chaton-userbar_right .chaton-whatsappbtn{
    background:#ffffff;
}
.chaton-needchat{
    display: flex;
    padding: 10px 20px;
    align-items: center;
    box-shadow: 0px 2px 4px rgb(40 41 61 / 4%), 0px 8px 16px rgb(96 97 112 / 16%);
    border-radius: 10px 10px 0px 0px;
    cursor: pointer;
}
.chaton-needchat svg{
    width: 24px;
    height: 24px;
    margin: 0 10px 0 0;
}
.chaton-needchat h6{
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    color:#ffffff !important;
}
.chaton-layout-one .chaton-chatfloatholder{
    bottom: 0;
    right: 20px;
}
.chaton-layout-one .chaton-chatsidebar_float.chaton-users-list {
    top: 20vh;
    height: auto;
    bottom: 73px;   
}
.chaton-opnchatbox .chaton-whatsappside-responsive.chaton-opnchatbox .chaton-chat_sidebar {
    display: block !important;
}
.chaton-whatsappside-responsive:not(.chaton-layout-one) .chaton-users-list.chaton-chatsidebar_float.chaton-users-list {
    max-width: 100%;
    bottom: 0;
    top: 0;
    left: 0;
    z-index: 99999;
}
.chaton-whatsappside-responsive:not(.chaton-layout-one) .chaton-users-list .chaton-sidebarhead{
    border-radius: 0;
}
.chaton-whatsappside-responsive .chaton-layout-one .chaton-chatsidebar_float.chaton-users-list{
    right: 20px;
    width: 90%;
}
.chaton-layout-one .chaton-whatsappside-responsive.chaton-opnchatbox .chaton-chat_sidebar{
    display: block !important;
}
.chaton-whatsappside-responsive .chaton-users-list::after {
    position: absolute;
    content: '';
    right: 4px;
    bottom: -7px;
}
.chaton-whatsappside-responsive .chaton-users-list .chaton-sidebarhead {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 20px 16px 50px;
}
.chaton-whatsappside-responsive:not(.chaton-layout-one) .chaton-sidebarhead > h2 {
    margin: 0 0 4px;
    font-size: 16px;
    line-height: 17px;
}
.whatsappside-responsive .chaton-users-list .conversation-list {
    height: calc(100% - 265px);
}
.chaton-closeremovechat{
     position: absolute;
    right: 20px;
    text-decoration: none;
    display: inline-block;
    top: 20px;
}
.chaton-closeremovechat i{
    color:#fff;
    font-size:25px;
}
.chaton-layout-one.chaton-layout-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    background: rgb(0 0 0 / 50%);
}
.chaton-layout-one.chaton-whatsappside-responsive .chaton-users-list::after {
    position: absolute;
    content: '';
    right: 34px;
    bottom: -7px;
}
.chaton-users-list.chaton-chatsidebar-widgetclose.chaton-chatsidebar_float {
    opacity: 0;
    right: 0;
    bottom: 0;
    visibility: hidden;
    transform: scale(0);
    transition: all .3s ease-in-out;
}
.chaton-layout-one.chaton-opnchatbox .chaton-users-list {
    display: none;
}
.chaton-layout-one.chaton-whatsappside-responsive .chaton-floatchat {
    right: 20px;
}
.chaton-whatsappside-responsive .chaton-whatsappchat-responsive .chaton-message[data-v-42308e4f] {
    max-width: 290px;
}
.chaton-whatsapp-rtl.chaton-layout-one .chaton-needchat svg{
    margin-left: 10px;
    margin-right: 0;
}
.chaton-whatsapp-rtl.chaton-layout-one .chaton-users-list {
    left: 20px;
    right: auto;
}
.chaton-whatsapp-rtl.chaton-layout-one  .chaton-users-list::after {
    right: auto;
    left: 48px;
}
.chaton-whatsapp-rtl.chaton-layout-one.chaton-whatsappside-responsive .chaton-floatchat {
    left: 20px;
    right: auto;
}
.chaton-whatsapp-rtl.chaton-layout-one  .chaton-iconclosered {
    justify-content: flex-start;
}
.chaton-whatsapp-rtl .chaton-chatsidebar_float.chaton-users-list {
    right: auto;
    left: 20px;
}
.chaton-whatsapp-rtl .chaton-floatholdertwo .chaton-floatchat {
    left: 450px;
    right: auto;
}
.chaton-whatsapp-rtl.chaton-layout-one.chaton-whatsappside-responsive .chaton-chatfloatholder {
    right: auto;
    left: 44px;
}
.chaton-whatsapp-rtl .chaton-users-list .chaton-sidebarhead svg {
    right: 20px;
    left: auto;
}
.chaton-layout-one.chaton-whatsapp-rtl .chaton-users-list .chaton-sidebarhead svg{
    right: 20px;
    transform: translate(0%, -50%);
}
.chaton-whatsapp-rtl .chaton-users-list .chaton-sidebarhead svg{
    right: 0;
    transform: rotate(180deg);
}
.chaton-layout-one.chaton-whatsapp-rtl .chaton-floatchat {
    right: auto;
    left: 443px;
}
.chaton-layout-one.chaton-whatsapp-rtl  .chaton-widgetclose ~ .chaton-chatfloatholder .chaton-floatchat {
    right: auto;
    left: 299px;
}
.chaton-whatsapp-rtl  .chaton-users-list .chaton-sidebarhead {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 67px 16px 20px;
}
.chaton-whatsapp-rtl  .chaton-floatholdertwo .chaton-floatchat_title h2{
    padding-left: 20px;
    padding-right: 0;
}
.chaton-whatsapp-rtl .chaton-users-list .chaton-closeremovechat {
    left: 20px;
    right: auto;
}
.chaton-whatsapp-rtl .chaton-users-list  .chaton-whatsappchat-responsive .chaton-userinfo_title_img[data-v-42308e4f]{
    margin-right: 0 !important;
    margin-left: 10px !important;
}
.chaton-whatsapp-rtl .chaton-users-list  .chaton-backtolist[data-v-42308e4f] {
    margin-left: 15px;
    margin-right: 0;
    transform: rotate(180deg);
}
.chaton-layout-one .chaton-widgetclose ~ .chaton-chatfloatholder .chaton-floatchat {
    right: 275px;
}

@media (max-width: 480px){
    .chaton-users-list .chaton-userbar_title > em,
    .chaton-users-list .chaton-userbar_title > p span{
        font-size: 12px;
    }
    .chaton-layout-one.chaton-whatsappside-responsive .chaton-chatsidebar_float {
        max-width: 340px;
    }
    .chaton-layout-one .chaton-users-list .chaton-sidebarhead > h2{
        font-size: 16px;
    }
    .chaton-layout-one .chaton-users-list .conversation-list li {
        padding: 10px !important;
    }
    .chaton-layout-one .chaton-userbar_title h3 {
        font-size: 16px;
        line-height: 17px;
    }
    .chaton-layout-one .chaton-userbar_profile img {
        height: 40px;
    }
    .chaton-layout-one  .chaton-userbar_profile {
      max-width: 40px;
    }
    .chaton-layout-one.chaton-whatsappside-responsive .chaton-floatchat{
        max-width: 340px;
    }
    .chaton-whatsapp-rtl.chaton-layout-one.chaton-whatsappside-responsive .chaton-floatchat {
    left: 20px;
    right: auto;
}
}
@media (max-width: 360px){
.chaton-layout-one.chaton-whatsappside-responsive .chaton-floatchat {
    max-width: 290px;
}
.chaton-layout-one .conversation-list {
    padding: 0;
    height: calc(100% - 198px);
}
.chaton-layout-one.chaton-whatsappside-responsive .chaton-chatsidebar_float {
    max-width: 290px;
}
}
</style>